module.exports = __webpack_public_path__ + "static/media/about-1.68b127d7.jpg";